import moment from "moment";

export default function stakeholderReducer(state = {
    pullout: false,
    current_booking: null,
    pullout_edit: null,
    booking_vehicles: [],
    current_bookings: [],
    organized_bookings: {},
    current_date: moment().startOf('day'),
    user_list: [],
    shuser_list: [],
    vehicle_list: [],
    vehicle_tier_list: [],
    user_tier_list: [],
    outstanding_media_list: [],
    completed_media_list: [],
    dismissed_media_list: [],
    booking_request_list: [],
    user_request_list: [],
    vehicle_reminder_list: [],
    damaged_vehicle_list: [],
    current_vehicle: {},
    current_vehicle_details: {},
    current_profile_details: {},
    current_overlay_media_breakdown: {},
    current_overlay_media_average: {},
    previous_filters: {},
    sort_direction: null,
    sort_filter: null,
    num_days_generated: 20,
    booking_next_page: null,
    inventory: {},
}, action) {
    switch(action.type) {
        case "SET_BOOKING" :{
            return state = {
                ...state,
                pullout: true,
                current_booking: {
                    ...action.payload,
                    edit: false,
                    new: false,
                }
            }
        }

        case "SET_BOOKING_EDIT" :{
            return state = {
                ...state,
                pullout: true,
                current_booking: {
                    ...action.payload,
                    edit: true
                }
            }
        }

        case "SET_BOOKING_NEW" :{
            return state = {
                ...state,
                pullout: true,
                current_booking: {
                    ...action.payload,
                    new: true
                },
            }
        }

        case "CLOSE_PULLOUT" :{
            return state = {
                ...state,
                pullout: false,
                current_booking: null,
            }
        }

        case "END_PULLOUT_EDIT": {
            return state = {
                ...state,
                pullout_edit: false,
                current_booking: {
                    ...action.payload,
                    edit: false
                }
            }
        }

        case "UPDATE_NUM_DAYS_GENERATED" :{
            return state = {
                ...state,
                num_days_generated: action.payload
            }
        }

        case "UPDATE_BOOKING_NEXT_PAGE" :{
            return state = {
                ...state,
                booking_next_page: action.payload
            }
        }

        case "SET_CURRENT_VEHICLE" :{
            return state = {
                ...state,
                current_vehicle: action.payload
            }
        }

        case "SET_CURRENT_VEHICLE_DETAILS" :{
            return state = {
                ...state,
                current_vehicle_details: action.payload
            }
        }

        case "SET_CURRENT_PROFILE_DETAILS" :{
            return state = {
                ...state,
                current_profile_details: action.payload
            }
        }

        case "SET_BOOKING_VEHICLES_LIST" :{
            return state = {
                ...state,
                booking_vehicles: action.payload
            }
        }
        

        case "SET_CURRENT_BOOKINGS_LIST" :{
            return state = {
                ...state,
                current_bookings: action.payload
            }
        }

        case "SET_ORGANIZED_BOOKINGS_LIST" :{
            return state = {
                ...state,
                organized_bookings: action.payload
            }
        }

        case "SET_VEHICLE_LIST" :{
            return state = {
                ...state,
                vehicle_list: action.payload
            }
        }

        case "SET_USER_LIST" :{
            return state = {
                ...state,
                user_list: action.payload
            }
        }

        case "SET_SHUSER_LIST" :{
            return state = {
                ...state,
                shuser_list: action.payload
            }
        }

        case "SET_VEHICLE_TIER_LIST" :{
            return state = {
                ...state,
                vehicle_tier_list: action.payload
            }
        }

        case "SET_USER_TIER_LIST" :{
            return state = {
                ...state,
                user_tier_list: action.payload
            }
        }

        case "SET_OUTSTANDING_MEDIA_LIST" :{
            return state = {
                ...state,
                outstanding_media_list: action.payload
            }
        }

        case "SET_COMPLETED_MEDIA_LIST" :{
            return state = {
                ...state,
                completed_media_list: action.payload
            }
        }

        case "SET_DISMISSED_MEDIA_LIST" :{
            return state = {
                ...state,
                dismissed_media_list: action.payload
            }
        }

        case "SET_BOOKING_REQUEST_LIST" :{
            return state = {
                ...state,
                booking_request_list: action.payload
            }
        }

        case "SET_USER_REQUEST_LIST" :{
            return state = {
                ...state,
                user_request_list: action.payload
            }
        }

        case "SET_VEHICLE_REMINDER_LIST" :{
            return state = {
                ...state,
                vehicle_reminder_list: action.payload
            }
        }

        case "SET_DAMAGED_VEHICLE_LIST" :{
            return state = {
                ...state,
                damaged_vehicle_list: action.payload
            }
        }

        case "SET_CURRENT_DATE" :{
            return state = {
                ...state,
                current_date: action.payload
            }
        }

        case "SET_ORGANIZED_MEDIA" :{
            return state = {
                ...state,
                current_overlay_media_breakdown: action.payload.media_breakdown,
                current_overlay_media_average: action.payload.media_average
            }
        }

        case "UPDATE_FILTER" :{
            return state = {
                ...state,
                sort_direction: action.payload.sort_direction,
                sort_filter: action.payload.sort_filter,
                previous_filters: action.payload.previous_filters
            }
        }

        case "SET_ALERTBAR_LISTS": {
            return state = {
                ...state,
                booking_request_list: action.payload.booking_request_list,
                user_request_list: action.payload.user_request_list,
                vehicle_reminder_list: action.payload.vehicle_reminder_list,
                damaged_vehicle_list: action.payload.damaged_vehicle_list,
                outstanding_media_list: action.payload.outstanding_media_list
            }
        }

        case "CREATE_INVENTORY": {
            return state = {
                ...state,
                inventory: {
                    shouldCreate: true,
                    shouldUpdate: false,
                    value: {}
                }
            }
        }

        case "UPDATE_INVENTORY": {
            return state = {
                ...state,
                inventory: {
                    shouldCreate: false,
                    shouldUpdate: true,
                    value: action.payload
                }
            }
        }

        case "CLEAN_INVENTORY": {
            return state = {
                ...state,
                inventory: {}
            }
        }

        default: {

        }
    }

    return state;
}